/* Προαιρετικό: φως στο ποντίκι + spotlight στις κάρτες προϊόντων. Δεν αλλάζει τη δομή. */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(!reduce&&!matchMedia('(pointer:coarse)').matches){
    var g=document.createElement('div');g.id='vt-glow';g.setAttribute('aria-hidden','true');document.body.appendChild(g);
    var gx=-999,gy=-999,tx=-999,ty=-999,on=false;
    addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;if(!on){on=true;g.style.opacity=1}});
    document.addEventListener('mouseleave',function(){g.style.opacity=0;on=false});
    (function loop(){gx+=(tx-gx)*.14;gy+=(ty-gy)*.14;g.style.transform='translate('+gx+'px,'+gy+'px)';requestAnimationFrame(loop)})();
  }
  document.addEventListener('pointermove',function(e){
    var c=e.target.closest&&e.target.closest('.grid-product__content');if(!c)return;
    var r=c.getBoundingClientRect();c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px');
  });
})();